import { render, staticRenderFns } from "./VpcTab.vue?vue&type=template&id=3b5fb63c&scoped=true&"
import script from "./VpcTab.vue?vue&type=script&lang=js&"
export * from "./VpcTab.vue?vue&type=script&lang=js&"
import style0 from "./VpcTab.vue?vue&type=style&index=0&id=3b5fb63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5fb63c",
  null
  
)

export default component.exports